import { FcsPermissionManagementLoginApproval } from "@/feature-flags/flags-management-login-approval";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

const ManagementLoginApproval = () =>
  import(
    /* webpackChunkName: "ManagementLoginApproval" */ "@/app/ui/views/management-login-approval/index.vue"
  );

export default [
  {
    path: "/management-login-approval",
    component: Layout,
    name: "management-login",
    redirect: "/management-login-approval/approval",
    meta: {
      newLayout: true,
      header: true,
      showIconNotification: true,
      name: "Manajemen Login & Perangkat",
      icon: "logout",
      permission: [
        FcsPermissionManagementLoginApproval.permission_tab_approval_enable,
        FcsPermissionManagementLoginApproval.permission_tab_device_enable,
        FcsPermissionManagementLoginApproval.permission_tab_history_enable
      ]
    },
    children: [
      {
        path: "approval",
        name: "ManagementLoginApproval",
        component: ManagementLoginApproval,
        meta: {
          permission:
            FcsPermissionManagementLoginApproval.permission_tab_approval_enable
        }
      },
      {
        path: "device",
        name: "ManagementLoginDevice",
        component: ManagementLoginApproval,
        meta: {
          permission:
            FcsPermissionManagementLoginApproval.permission_tab_device_enable
        }
      },
      {
        path: "history",
        name: "ManagementLoginHistory",
        component: ManagementLoginApproval,
        meta: {
          permission:
            FcsPermissionManagementLoginApproval.permission_tab_history_enable
        }
      }
    ]
  }
];
